import { call, put, select, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import { createUserActions, updateUserActions, userActions, usersActions } from "./users.actions";
import { createUserApi, getUserApi, getUsersApi, updateUserApi } from "./users.api";
import { UserDto } from "./users.dtos";

function* setUsers(result: UserDto[], newItems: UserDto[]) {
    result.forEach(i => {
      let oldItemIndex = newItems.findIndex(s => s.id === i.id);
      if (oldItemIndex === -1) newItems.push(i);
      else newItems[oldItemIndex] = i;
    }); 
    yield put({ type: getType(usersActions.success), payload: newItems });
    sessionStorage.setItem(`users`, JSON.stringify(newItems));
}

function* handleGetUsers(request: ReturnType<typeof usersActions.request>) {
    const storeList: UserDto[] = yield select(state => state.users.list);
    const userStorage = sessionStorage.getItem(`users`);
    const sessionUsers = userStorage === null ? [] : JSON.parse(userStorage) as UserDto[];
    const users: UserDto[] = 
    // storeList !== undefined && storeList.length !== 0 ? storeList :
    //   sessionUsers.length !== 0 ? sessionUsers :
        yield call(getUsersApi);
  
    yield put({ type: getType(usersActions.success), payload: users });
    sessionStorage.setItem(`users`, JSON.stringify(users));
}

function* handleGetUser(request: ReturnType<typeof userActions.request>) {
    const storeUser: UserDto = yield select(state => state.users.user);
    const user: UserDto = (storeUser !== undefined && storeUser.id !== undefined && storeUser.id === request.payload) ? storeUser : yield call(getUserApi, request.payload);
  
    yield put({ type: getType(userActions.success), payload: user });
  }

function* handleUpdateUser(request: ReturnType<typeof updateUserActions.request>) {
    const storeList = yield select(state => state.users.list);
    const updatedUser: UserDto = yield call(updateUserApi, request.payload);
  
    yield put({ type: getType(userActions.success), payload: updatedUser });
  
    if (storeList !== undefined && storeList.length !== 0)
      yield setUsers([updatedUser], JSON.parse(JSON.stringify(storeList)) as UserDto[]);
}
  
function* handleCreateUser(request: ReturnType<typeof createUserActions.request>) {
    const storeList = yield select(state => state.users.list);
    const createdUser: UserDto = yield call(createUserApi, request.payload);
  
    yield put({ type: getType(userActions.success), payload: createdUser });
  
    if (storeList !== undefined && storeList.length !== 0)
      yield setUsers([createdUser], JSON.parse(JSON.stringify(storeList)) as UserDto[]);
}

export function* watchGetUsersRequest() {
    try {
      yield takeLatest(getType(usersActions.request), handleGetUsers);
    }
    catch (err) {
      console.log(err);
    }
}

export function* watchGetUserRequest() {
    try {
      yield takeLatest(getType(userActions.request), handleGetUser);
    }
    catch (err) {
      console.log(err);
    }
}

export function* watchUpdateUserRequest() {
    try {
      yield takeLatest(getType(updateUserActions.request), handleUpdateUser);
    }
    catch (err) {
      console.log(err);
    }
}
  
export function* watchCreateUserRequest() {
    try {
      yield takeLatest(getType(createUserActions.request), handleCreateUser);
    }
    catch (err) {
      console.log(err);
    }
}